import { CSSProperties } from 'styled-components';

import { residenceTypes } from '~src/constants/residence';
import { Residence, ResidenceType } from '~src/model';

import { ResidenceFormProps } from './types';

export const getCalculatorResidenceFormInputProps = ({
  residence,
  onUpdate,
  guessedValues,
  locked,
  style,
}: ResidenceFormProps & { style?: CSSProperties }) => {
  const updateResidenceInput = (input: Partial<Residence>) => {
    const updatedResidence = { ...residence, ...input };
    onUpdate?.(updatedResidence as Residence);
  };

  const isGuessed = (key: 'area' | 'areaHeated' | 'floors' | 'type') =>
    !!guessedValues?.[key] && guessedValues?.[key] === residence?.[key] ? 'warning' : undefined;
  const inputStyle = { margin: '0 0 24px', ...style };

  return [
    {
      inputType: 'select',
      style: inputStyle,
      label: 'Boligtype',
      value: residence?.type,
      placeholder: residenceTypes[0]?.label,
      disabled: locked,
      options: residenceTypes,
      status: isGuessed('type'),
      onChange: (value?: string) => updateResidenceInput({ type: value as ResidenceType }),
    },
    {
      inputType: 'number',
      style: inputStyle,
      label: 'Antal etager',
      value: residence?.floors,
      placeholder: 1,
      disabled: locked,
      options: residenceTypes,
      status: isGuessed('floors'),
      onChange: (floors?: number) => updateResidenceInput({ floors }),
    },
    {
      inputType: 'number',
      style: inputStyle,
      label: 'Boligareal',
      disabled: locked,
      placeholder: '123',
      value: residence?.area,
      status: isGuessed('area'),
      onChange: (area?: number) => updateResidenceInput({ area }),
    },
    {
      inputType: 'number',
      style: inputStyle,
      label: 'Opvarmet boligareal',
      placeholder: '100',
      disabled: locked,
      value: residence?.areaHeated,
      status: isGuessed('areaHeated'),
      onChange: (areaHeated?: number) => updateResidenceInput({ areaHeated }),
    },
  ];
};
